<template>
  <div id="resumeAbs" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row mt-5">
        <div class="col-10 mx-auto mt-5">
          <div>
            <h1>Resumen de Ausentismos</h1>
          </div>

          <div class="d-flex align-items-center pt-4">
            <b-form-select class="col-4" v-model="selectedGrafic" :options="optionsGrafic" @change="selectFilter()"></b-form-select>
            <v-select v-if="societyFilter && user.core_role_id == 19" class="col-5" label="name" :options="optionsSocietys" v-model="selectedSociety" @input="filterBySociety(selectedSociety.id)">
              <template slot="no-options">
                No se encontro ninguna sociedad
              </template>
            </v-select>
            <b-button v-if="show == 'tables' || show == 'stadistics'" @click="popoverShow = !popoverShow" id="popover-reactive-1" variant="primary" ref="button" class="buttonColapse d-flex align-items-center ml-5">
              <div class="textButtonColapse mx-4 d-flex align-items-center justify-content-between">
                <p class="m-0 pr-2">Filtro</p>
                <img class="centerImg1 arrow" src="@/assets/images/icons/filter_list.svg" width="15px">
              </div>
            </b-button>
            <b-popover
                target="popover-reactive-1"
                triggers="click"
                :show.sync="popoverShow"
                placement="auto"
                container="filterContainer"
                class="p-3 popFilter"
                ref="popover"
            >
              <template #title>
                <b-button @click="cleanDataFilter" class="close" aria-label="Close">
                  <span class="d-inline-block" aria-hidden="true">&times;</span>
                </b-button>
                Filtro de Busqueda
              </template>

              <p class="my-1 separate" style="font-size:14px">Fecha</p>
              <div class="d-flex flex-column mt-2">
                <div>
                  <p class="my-1">Desde</p>
                  <b-form-datepicker
                      :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                      v-model="filterFrom"
                      locale="es-CO"></b-form-datepicker>
                </div>
                <!-- Selecciona fecha final -->
                <div>
                  <p class="my-1">Hasta</p>
                  <b-form-datepicker
                      :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                      :min="filterFrom"
                      v-model="filterTo"
                      locale="es-CO"></b-form-datepicker>
                </div>
              </div>
              <b-button @click="setFilter" size="sm" class="px-3 btn-success mt-3 mx-auto">Aplicar Filtros</b-button>
            </b-popover>
          </div>
        </div>
        <div class="col-10 mx-auto mt-5 d-flex align-items-center" style="width:100%;">
          <div class="filter-areas col-12 p-0 mb-5">
            <div v-if="areaTree[0]">
              <div class="col-12 p-0 m-0">
                <div class=""><p>Filtros por áreas</p></div><div class=""><hr></div>
              </div>
              <div class="d-flex">
                <div v-for="(area,index) in areaTree" :key="index" class="col-2 p-0 ml-1">
                  <v-select class="p-0 ml-1" label="name" :options="areaTree[index].optSelect" v-model="areaSelected[index]" @input="incrementFilter(index + 1)"></v-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div class="mt-5" v-if="loading" id="loader"></div>
      <div v-else class="p-0 col-10 mx-auto">
        <div v-if="show == ''" class="mt-5 text-center">
            <img class="centerImg1" src="@/assets/images/icons/select-category-stadistics.svg" width="20%">
            <p>Selecciona una <b>categoría</b> para visualizar el informe</p>
        </div>
        <Stadistics v-if="show == 'stadistics'" :totalAbsenteeism="summary" :justStadistics="true" />
        <UpdateEmployee  v-if="show == 'employees'" />
        <div v-if="show == 'tables'" class="card mt-3">
            <div class="d-flex mt-3">
                <button @click="changeType('specific')" class="buttonTables">Especifico</button>
                <button @click="changeType('general')" class="buttonTables">General</button>  
            </div>
                <div class="mt-3 table-responsive tableAbs">
                        <datatable
                        :columns="dataTable.columns"
                        :data="dataTable.rows"
                        class="col-12 mt-2"
                        >
                        </datatable>
                    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
                        <Pagination :data="tableReport" :limit="10" @pagination-change-page="loadRowsPagination"></Pagination>
                    </div>
                 </div>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import HeadingUser from "../../components/user/HeadingUser.vue";
import Stadistics from "../../components/healthTracker/stadistics.vue"
import UpdateEmployee from "./updateEmployee.vue"
export default {
    name: "novelties",
    components: {
    MainBarMenuV2,
    HeadingUser,
    Stadistics,
    Pagination,
    UpdateEmployee
     },
     data() {
         return {
             filterFrom:'',
             filterTo:'',
             show: '',
             popoverShow:false,
             selectedGrafic:null,
             optionsGrafic:[],
             menu:false,
            selectedSociety:null,
            optionsSocietys:[{value:null,text:'Elige una sociedad'}],
            societyFilter:false,
            stadistics:false,
            generalTable:false,
            areaTree:[],
            areaSelected:[],
            userSociety:'',
            dataTable:{
                columns: [],
                rows: [],
            },
            typeTable:'specific'
         }
     },
     beforeMount(){
         this.actUserLocalStorage()
         switch (this.user.core_role_id) {
             case 17:
                 this.optionsGrafic = [
                    {value:null,text:'Elige una categoria'},
                    {value:'area',text:'Sitio'},
                    {value:'charges',text:'Cargos'},
                 ]
                 break;
            case 18:
                 this.optionsGrafic = [
                    {value:null,text:'Elige una categoria'},
                    // {value:'society',text:'Sociedad'},
                    {value:'area',text:'Sitio'},
                    {value:'charges',text:'Cargos'},
                 ]
                 break;
            case 2:
                 this.optionsGrafic = [
                    {value:null,text:'Elige una categoria'},
                    {value:'area',text:'Sitio'},
                    {value:'charges',text:'Cargos'},
                    {value:'employees',text:'Empleados'}
                 ]
                 break;
         
             default:
                 break;
         }
     },
     computed: {
    ...mapState("modOhAnalyst", [
        "loading",
        "loading2",
        "error",
        "message",
        "areas",
        "societys",
        "summary",
        "tableReport"
      ]),
    ...mapState("modCore", ["user"]),
  },
     methods: {
         ...mapActions("modOhAnalyst", [
        'actGetAllSocietys',
        'actGetAllAreas',
        'actFilterStadisticsBy',
        'actGetTablesReport'
        ]),
        ...mapActions("modCore", ["actUserLocalStorage"]),

        cleanDataFilter(){
          this.popoverShow = false
        },

        incrementFilter(level){
            let data = {}
            this.areaTree[level] = {}
            if(this.areaTree[0]){
                // elimina las opciones hijas, si el padre es deseleccionado
                if(this.areaSelected[level - 1] == null){
                    this.areaTree.splice(level, 1)
                    this.areaSelected.splice(level, 1)
                    console.log(this.areaTree)
                    console.log(this.areaSelected)
                }else{
                    console.log('1')
                // pregunta si el elpadre.tree es un array o un objeto
                    if(this.areaTree[level - 1].tree[0]){
                        // como si es un array, lo recorre
                        this.areaTree[level - 1].tree.forEach(x => {
                        // en busqueda del padre correcto
                            if(x.id == this.areaSelected[level - 1].id){
                                // pregunta si el padre tiene más hijos
                                if(x.children){
                                    this.areaTree[level] = {
                                        tree:x.children,
                                        optSelect:[]
                                    }
                                    this.areaTree[level].tree.forEach(x => {
                                        this.areaTree[level].optSelect.push({
                                            id:x.id,
                                            macro: x.ht_macro_ent_name_id,
                                            name:x.label
                                        })
                                    })
                                }else{
                                    this.areaTree.splice(level, 1);
                                }
                            }
                        })
                    }else{
                        // como si es un objeto, ahora pregunta si tiene más hijos
                        if(this.areaTree[level - 1].tree.children){
                            this.areaTree[level] = {
                                tree:this.areaTree[level - 1].tree.children,
                                optSelect:[]
                            }
                        }
                        else{
                            this.areaTree.splice(level, 1);
                        }
                    }
                }
                data = {
                    macro: (this.selectedSociety?this.selectedSociety.id:this.userSociety),
                    area: (this.areaSelected[level - 1]?this.areaSelected[level - 1].id:''),
                    type:this.typeTable
                }
                if(this.show == 'stadistics'){
                    this.actFilterStadisticsBy(data)
                    return
                }else if(this.show == 'tables'){
                    this.loadRows(data) 
                    return
                }
            }else{
                if(this.areas[0]){
                this.areaSelected = []
                this.areaTree = []
                this.areaTree[0] = {
                    tree:this.areas,
                    optSelect:[]
                }
                this.areas.forEach(x => {
                    this.areaTree[0].optSelect.push({
                        id:x.id,
                        macro: x.ht_macro_ent_name_id,
                        name:x.label
                    })
                })
                }                           
            }
        },
        deselected(){
            console.log('deseleccionado')
        },
         selectFilter(){
             this.userSociety = this.getUserData.ht_macro_ent_name_id
             switch (this.selectedGrafic) {
                 case 'society':

                     break;

                 case 'area':
                     if(this.user.core_role_id !== 19){
                        this.filterBySociety(this.userSociety)
                        this.show = 'stadistics'
                    }else{
                        this.optionsSocietys = [{value:null,text:'Elige una sociedad'}]
                        this.show = 'stadistics'
                        this.actGetAllSocietys().then(() => {
                            this.societyFilter = true
                            this.societys.forEach(x=> {
                                this.optionsSocietys.push({
                                    id:x.id,
                                    name:x.name
                                })
                            });
                        })
                    }
                     break;
                case 'charges':
                    this.show = 'tables'
                    this.typeTable = 'specific'
                    if(this.user.core_role_id !== 19){
                        this.filterBySociety(this.userSociety)
                    }else{
                        this.optionsSocietys = [{value:null,text:'Elige una sociedad'}]
                        this.actGetAllSocietys().then(() => {
                            this.societyFilter = true
                            this.societys.forEach(x=> {
                                this.optionsSocietys.push({
                                    id:x.id,
                                    name:x.name
                                })
                            });
                        })
                    }
                    break;
                case 'employees':
                    this.show = 'employees'
                    this.areaTree = []
                     break;
             }
         },
         filterBySociety(x){
             this.actGetAllAreas(x).then(() => {
                this.areaTree = []
                this.incrementFilter()
            })
            let data = {
                macro: x
            }
            if(this.selectedGrafic == 'area'){
                  this.actFilterStadisticsBy(data).then(() => {
                  this.show = 'stadistics'  
            })
            }else if(this.selectedGrafic == 'charges'){
                data = {
                macro: x,
                type:'specific'
                }
                this.loadRows(data)
               this.show = 'tables' 
            }
        },
        changeType(x){
            let areaSelected = this.areaSelected.length
            this.typeTable = x
            let data = {
                macro: (this.selectedSociety?this.selectedSociety.id:this.userSociety),
                type:x,
                area: (this.areaSelected[0]?(this.areaSelected[areaSelected - 1] == -1? '': (this.areaSelected[areaSelected - 1].id? this.areaSelected[areaSelected - 1].id:'')):'')
                }
            this.loadRows(data)
        },
        loadRows(data){
           this.actGetTablesReport(data).then(() => {
               if(this.typeTable == 'specific'){
                this.dataTable.columns = [
                            {
                                label: "Cargo",
                                field: "charge",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "Nombre/C.C",
                                field: "name",
                                align: "left",
                                headerClass: "theading",
                                interpolate: true
                            },
                            {
                                label: "Días",
                                field: "days",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "Tipo",
                                field: "type",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "Fecha Inicial",
                                field: "startDate",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "Fecha final",
                                field: "endDate",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "DX",
                                field: "dx",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "Certificado",
                                field: "certificate",
                                align: "left",
                                headerClass: "theading",
                                interpolate: true
                            },
                            
                ]
                this.dataTable.rows = []
                this.tableReport.data.forEach(x => {
                    let status = {}
                            switch (x.status){
                                case 'pending' :
                                status = {
                                    color:'#FFF4EC',
                                    icon: 'orange-clock.svg',
                                    text: 'Pendiente'
                                }
                                break
                                case 'received':
                                status = {
                                    color:'#EDF9F0',
                                    icon: 'check.svg',
                                    text: 'Recibido'
                                }
                                break 
                                case 'not-apply':
                                status = {
                                    color:'#F5F5F5',
                                    icon: 'close_gray.svg',
                                    text: 'No Aplica'
                                }
                                break                      
               }
                this.dataTable.rows.push({
                        charge:x.charge,
                        startDate:x.start_date,
                        endDate:x.end_date,
                        days:x.days,
                        type:x.type,
                        name:`${x.name}<br>C.C ${x.cc}`,
                        dx:x.dx,
                        certificate: `<span class="status" style="background-color:${status.color}"><img class="centerImg1 mr-1"  src="${require('@/assets/images/icons/' + status.icon)}" width="15px">${status.text}</span>`
                    })
                })
               }else if(this.typeTable == 'general'){
                   this.dataTable.columns = [
                            {
                                label: "Cargo",
                                field: "charge",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "Nombre/C.C",
                                field: "name",
                                align: "left",
                                headerClass: "theading",
                                interpolate: true
                            },
                            {
                                label: "Días totales perdidos",
                                field: "days",
                                align: "left",
                                headerClass: "theading",
                            },
                            {
                                label: "Horas totales perdidas",
                                field: "hours",
                                align: "left",
                                headerClass: "theading",
                            }
                            
                ]
                this.dataTable.rows = []
                this.tableReport.data.forEach(x => {
                    this.dataTable.rows.push({
                            charge:x.charge,
                            days:x.total_days,
                            hours:x.total_hours,
                            name:`${x.name}<br>C.C ${x.cc}`,
                    })
                })
               }
            })
        },
        loadRowsPagination(page = 1){
            let areaSelected = this.areaSelected.length
            let data = {
                macro: (this.selectedSociety?this.selectedSociety.id:this.userSociety),
                type:this.typeTable,
                area: (this.areaSelected[0]?(this.areaSelected[areaSelected - 1] == -1? '': (this.areaSelected[areaSelected - 1].id? this.areaSelected[areaSelected - 1].id:'')):''),
                page:page,
            }
          if (this.filterFrom !== '' && this.filterTo !== '') {
            data.start_date = this.filterFrom
            data.end_date = this.filterTo
          }
          this.loadRows(data)
        },
        setFilter(){
            let areaSelected = this.areaSelected.length
            let data = {
                start_date:this.filterFrom,
                area: (this.areaSelected[0]?(this.areaSelected[areaSelected - 1] == -1? '': (this.areaSelected[areaSelected - 1].id? this.areaSelected[areaSelected - 1].id:'')):''),
                macro: (this.selectedSociety?this.selectedSociety.id:this.userSociety),
                end_date:this.filterTo,
                type:this.typeTable,
            }
            if(this.show == 'stadistics'){
                    this.actFilterStadisticsBy(data)
                    return
                }else if(this.show == 'tables'){
                    this.loadRows(data) 
                    return
            }
        }
     },
}
</script>

<style lang="scss">
#resumeAbs {
    .buttonColapse{
        background: rgba(38, 152, 135, 0.14);
        border: 2px solid #269887;
        color:#269887;
        font-size: 14px;
        border-radius: 60px;
        height: 50px;
    }
    .menu{
        .dropdown-toggle, .btn-menu{
            background-color: #FFFFFF !important;
            color: black;
            border: none;
            font-size: 14px;
            font-weight: 600;
            border-left:2px solid rgb(187, 187, 187);
        }
        .dropdown-menu{
            z-index: 10;
            min-width: 150px;
            min-height: 100%;
            border-radius: 15px;
                .dropdown-toggle{
                border: none;
                }
        }
        .childrenMenu {
            .dropdown-item, .dropdown-toggle{
                text-align: left;
                margin: 0;
                padding: 15px;
                min-width: 150px;
                min-height: 100%;
                font-size: 12px;
                font-weight: 100;
                border-radius: 15px;
            }
            .dropdown-toggle{
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .dropdown{
                margin: 0;
                padding: 0;
            }
        }
    }
    .vs__selected{
        height: 20px !important;
    }
    select.custom-select, .vs__dropdown-toggle {
        padding: 10px 10px;
        font-size: 15px;
        height: 50px;
        border-radius: 10px;
    }
    .filter-areas{
        .vs__dropdown-toggle {
        padding: 5px 5px;
        font-size: 10px;
        height: 30px;
        border-radius: 5px;
        }
        .vs__dropdown-menu{
            font-size: 10px;
            border-radius: 5px;
            li {
                padding: 3px;
            }
        }
    }
    .dropdown:hover>.dropdown-menu {
        display: block;
    }
    .table-views{
        box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
        border-radius: 8px;
        border:#DDDDDD solid 1px;
        padding: 0;
        margin: 30px 5px;
        .theading{
            width: 25%;
        }
    }
    .tableAbs{
        font-size: 13px;
    }
    .t-head{
        background-color: #F5F5F5;
        padding: 5px 15px;
        text-align: left;
    }
    input{
        padding: 10px 10px;
        font-size: 15px;
        height: 50px;
        border-radius: 10px;
    }
    .theading{
        padding: 10px 10px;
        background-color: #EEF2FA;
        text-align: left;
    }
    tbody tr td{
        padding: 10px 10px;
    }
    .nav-tabs{
        a{
            color:black;
            padding: 5px 15px;
        }
        a.active {
            background: rgba(38, 152, 135, 0.06);
            border-radius: 4px;
            border: 0;
            border-bottom: solid 3px;
            border-color: #269887;
        }
    }
    .status{
        padding: 3px 5px;
        border-radius: 20px;
        font-size: 10px;
    }
    .buttonTables{
        background-color: white;
        border: none;
        padding: 5px;
    }
}
</style>